let helper = require('./helper');
let FooterWidget = require('./FooterWidget');

let Utm = require('./Utm.js');
Utm.storeUrlParams('utm_source');
Utm.storeUrlParams('utm_campaign');
Utm.storeUrlParams('utm_medium');

module.exports = {
    init: function (pageContainer) {
        let that = this;
        that.addAds(pageContainer);
        helper.addEvent(document.body, 'thb_after_infinite_load', function () {
            that.addAds(this);
        });


        //init ststic units
        this.addAds(document.getElementById('body_button_units'), undefined, true);
        let fp_bounce_popup = document.getElementById('fp_bounce_popup');
        if(fp_bounce_popup) this.addAds(fp_bounce_popup, undefined, true);


        // Handle fixed footer and interstical units
        googletag.cmd.push(function () {
            googletag.pubads().addEventListener('slotRenderEnded', function (dfpEvent) {
                let addUnitPath = dfpEvent.slot.getAdUnitPath();
                if(addUnitPath === window.config.footerUnitName) that.handleFooterUnit(dfpEvent);
                // if(addUnitPath === window.config.interstUnitName) that.handleInterstUnit(dfpEvent);
            });
        });


        const every = 4000;
        let goal = every;
        helper.addEvent(window, 'slideScrolling', function () {
            // let covered = 0;
            if(window.lastScrollTop >= goal){
                goal = goal + every;
                // console.log('scrolled ' + every);
                if(that.dfpSlotsToRefresh.length){
                    let filteredSlots = that.dfpSlotsToRefresh.filter(slot => {
                        let slotHeight = document.querySelector('#' + slot.getSlotElementId() + ' iframe').clientHeight;
                        // console.log('slotHeight: ' + slotHeight);
                        return slotHeight > 1;
                    });
                    if(filteredSlots.length){
                        that._refreshSlots(
                            filteredSlots,
                            that._getPrebidConfigForSlots(filteredSlots)
                        );
                    }
                }
            }
        })

    },
    dfpSlotsIterator: 0,
    dfpSlots: [],
    dfpSlotsToRefresh: [],
    getRoxotSectorId: function() {
        try {
            let storageKey = 'roxot-sid';
            let groupId = localStorage.getItem(storageKey);
            if (groupId === null) {
                groupId = 1 + Math.floor(Math.random() * 100);
                localStorage.setItem(storageKey, groupId);
            }
            return '' + groupId;
        }
        catch (e) {
            return '' + 101;
        }
    },
    getRoxotDeep: function() {
        try {
            let storageKey = 'roxot-deep';
            let groupId = localStorage.getItem(storageKey);
            if (groupId === null) {
                groupId = 1 + Math.floor(Math.random() * 100);
                localStorage.setItem(storageKey, groupId);
            }
            return '' + groupId;
        }
        catch (e) {
            return '' + 101;
        }
    },
    getRoxotEvent: function() {
        return '' + (1 + Math.floor(Math.random() * 100));
    },
    addAds: function (container, direction, isFixedUnit) {
        let that = this;

        let adPlacements = that.getAdPlacementsWithinNScreensFromCurrent(container,
            helper.config.lazyLoadPreloadNScreens, direction, isFixedUnit);

        if(adPlacements.length == 0) return;

        // In case all adPlacements have div_added return now
        let amountOfAdPlacementsToProcess = 0;
        for (let i = 0; i < adPlacements.length; i++){
            if (adPlacements[i].dataset.state !== "div_added"){
                amountOfAdPlacementsToProcess++;
            }
        }
        if(amountOfAdPlacementsToProcess < 1) return;

        let adsPortion = [];
        let dfpSlotsPortion = [];



        this.listenForScroll(container);

        //set placement iterator
        for (let i = 0; i < adPlacements.length; i++) {
            let adPlacement = adPlacements[i];
            if (adPlacement.dataset.state === "div_added") continue;

            // anchored-footer
            if (adPlacement.dataset.adPositionType == 'anchoredfooter') {
                window.fp_anchoredfooter_iterator = window.fp_anchoredfooter_iterator || 0;
                let iterator = window.fp_anchoredfooter_iterator;
                window.fp_anchoredfooter_iterator++;


                adPlacement.setAttribute('data-counter', iterator);
                adPlacement.setAttribute('data-ad-position-type-N', 'anchoredfooter_' + iterator);
                if (iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'anchoredfooter_100_plus');
            }

            // in-content
            if (adPlacement.dataset.adPositionType == 'infeed') {
                window.fp_infeed_iterator = window.fp_infeed_iterator || 0;
                let iterator = window.fp_infeed_iterator;
                window.fp_infeed_iterator++;

                adPlacement.setAttribute('data-counter', iterator);
                adPlacement.setAttribute('data-ad-position-type-N', 'infeed_' + iterator);
                if (iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'infeed_100_plus');
            }

            // separator
            if (adPlacement.dataset.adPositionType == 'separator') {
                window.fp_separator_iterator = window.fp_separator_iterator || 0;
                let iterator = window.fp_separator_iterator;
                window.fp_separator_iterator++;

                adPlacement.setAttribute('data-counter', iterator);
                adPlacement.setAttribute('data-ad-position-type-N', 'separator_' + iterator);
                if (iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'separator_100_plus');
            }

            // sidebar
            if (adPlacement.dataset.adPositionType == 'rightslider') {
                window.fp_sidebar_iterator = window.fp_sidebar_iterator || 0;
                let iterator = window.fp_sidebar_iterator;
                window.fp_sidebar_iterator++;

                adPlacement.setAttribute('data-counter', iterator);
                adPlacement.setAttribute('data-ad-position-type-N', 'rightslider_' + iterator);
                if (iterator > 100) adPlacement.setAttribute('data-ad-position-type-N', 'rightslider_100_plus');
            }

        }

        for (let i = 0; i < adPlacements.length; i++) {
            let adPlacement = adPlacements[i];

            if (adPlacement.dataset.state === "div_added") continue;

            let unitName = adPlacement.dataset.adunitName;

            let unitSizes = (adPlacement.dataset.adunitSizes ? JSON.parse(adPlacement.dataset.adunitSizes) : undefined);
            let iterator = this.dfpSlotsIterator++;
            let unitDivId = 'div-gpt-ad-' + iterator;
            let ad_position_type = adPlacement.dataset.adPositionType || 0;
            let ad_position_type_N = adPlacement.dataset.adPositionTypeN || 0;
            let ad_position_sidebar = adPlacement.dataset.adPositionSidebar || 0;
            let utm_source;
            if(window.fp_utm_source){
                utm_source = window.fp_utm_source.replace(/[^A-Za-z0-9-_]/, '').substring(0, 40);
            }else {
                utm_source = 'Empty Value';
            }


            //add div with unic IDs
            adPlacement.setAttribute('data-state', 'div_added');
            adPlacement.innerHTML = `<div id="${unitDivId}"></div>`;

            // save unit ids in global variable
            window.pageAdUnits = window.pageAdUnits || [];
            window.pageAdUnits.push({
                unitName: unitName,
                unitDivId: unitDivId
            });

            let prebidConfig = this._getPrebidConfig(unitName, unitDivId);

            /* Getting consent cookie content */
            /*let consent = {
                1 : true,
                2 : true,
                3 : true,
                4 : true,
                5 : true
            };*/
            let consent = {
                1 : false, // Accessing a Device : Allow storing or accessing information on a user’s device.
                2 : false, // Advertising Personalisation : Allow processing of a user’s data to provide and inform personalised advertising (including delivery, measurement, and reporting) based on a user’s preferences or interests known or inferred from data collected across multiple sites, apps, or devices; and/or accessing or storing information on devices for that purpose.
                3 : false, // Analytics : Allow processing of a user’s data to deliver content or advertisements and measure the delivery of such content or advertisements, extract insights and generate reports to understand service usage; and/or accessing or storing information on devices for that purpose.
                4 : false, // Content Personalisation : Allow processing of a user’s data to provide and inform personalised content (including delivery, measurement, and reporting) based on a user’s preferences or interests known or inferred from data collected across multiple sites, apps, or devices; and/or accessing or storing information on devices for that purpose.
                5 : false // Matching Data to Offline Sources : Combining data from offline sources that were initially collected in other contexts
            };

            function createCookie(name, value, seconds) {
                if (seconds) {
                    let date = new Date();
                    date.setTime(date.getTime() + (seconds * 1000));
                    let expires = "; expires=" + date.toGMTString();
                    document.cookie = name + "=" + value + expires + "; path=/";
                } else {
                    document.cookie = name + "=" + value + "; path=/";
                }
            }

            function readCookie(name) {
                let nameEQ = name + "=";
                let ca = document.cookie.split(';');

                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];

                    while (c.charAt(0) == ' ') {
                        c = c.substring(1,c.length);
                    }

                    if (c.indexOf(nameEQ) == 0) {
                        return c.substring(nameEQ.length, c.length);
                    }
                }

                return null;
            }

            function eraseCookie(name) {
                createCookie(name, "", -1);
            }

            function cmpCallback(result) {
                let purposes = [];

                for (let i = 1; i <= 5; i++) {
                    purposes[i] = (result.standardPurposeConsents[i] ? 1 : 0);
                }

                document.cookie = "purposes=" + purposes.join(',').substr(1);

                eraseCookie("purposes");
                createCookie("purposes", purposes.join(',').substr(1), 2)
            }

            __cmp('getPublisherConsents', null, (result) => cmpCallback(result));

            let nameEQ = "purposes=";
            let ca = document.cookie.split(';');
            let cookie = null;

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) {
                    cookie = c.substring(nameEQ.length, c.length);
                }
            }

            if (cookie && cookie !== null) {
                let purposes = cookie.split(",");

                if (purposes !== null && purposes.length == 5) {
                    for (let i = 1; i <= 5; i++) {
                        consent[i] = (purposes[i - 1] == 1 ? true : false);
                    }
                }
            }

            //define slots
            //display slots
            googletag.cmd.push(function () {
                let nameEQ = "purposes=";
                let ca = document.cookie.split(';');
                let cookie = null;

                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) {
                        cookie = c.substring(nameEQ.length, c.length);
                    }
                }

                if (cookie && cookie !== null) {
                    let purposes = cookie.split(",");

                    if (purposes !== null && purposes.length == 5) {
                        for (let i = 1; i <= 5; i++) {
                            consent[i] = (purposes[i - 1] == 1 ? true : false);
                        }
                    }
                }

                if (consent[2]) {
                    // console.log("[DEBUG] DFP - consent ok");
                    googletag.pubads().setRequestNonPersonalizedAds(0);
                } else {
                    // console.log("[DEBUG] DFP - consent NOK");
                    googletag.pubads().setRequestNonPersonalizedAds(1);
                }

                that.dfpSlots[iterator] = googletag.defineSlot(unitName, unitSizes, unitDivId).addService(googletag.pubads());
                that.dfpSlots[iterator].prebidConfig = prebidConfig;
                // if (ad_position_type) that.dfpSlots[iterator].setTargeting('ad_position_type', ad_position_type);
                if (ad_position_type_N) that.dfpSlots[iterator].setTargeting('ad_position_type_N', ad_position_type_N);
                // if (ad_position_sidebar) that.dfpSlots[iterator].setTargeting('ad_position_sidebar', ad_position_sidebar);
                // that.dfpSlots[iterator].setTargeting('utm_source', utm_source);
                if(window.config.utm_key){
                    let source = window.fp_utm_source || 'src-na';
                    source = source.replace(/_/g, '-');

                    let medium = window.fp_utm_medium || 'med-na';
                    medium = medium.replace(/_/g, '-');

                    let campaign = window.fp_utm_campaign || 'cmp-na';
                    campaign = campaign.replace(/_/g, '-');

                    let value = [source, medium, campaign].join('_').substring(0, 40);

                    that.dfpSlots[iterator].setTargeting(window.config.utm_key, value);
                }
                // if(window.fp_utm_campaign) that.dfpSlots[iterator].setTargeting('utm_campaign', window.fp_utm_campaign);
                let matches = window.location.pathname.match(/\/([^\/]+)\/$/);
                if (matches !== null) {
                    let post_slug = matches[1].substring(0, 40);
                    that.dfpSlots[iterator].setTargeting('post_slug', post_slug);
                }

                let category_slug_dfp;
                if(window.category_slug_dfp){
                    category_slug_dfp = window.category_slug_dfp;
                }else{
                    let post_detail = document.querySelectorAll('.post-detail')[0];
                    category_slug_dfp = post_detail && post_detail.dataset.catSlugDfp;
                    window.category_slug_dfp = category_slug_dfp;
                }
                if(category_slug_dfp) category_slug_dfp = category_slug_dfp.split('#');
                if(category_slug_dfp && category_slug_dfp.length === 1) category_slug_dfp = category_slug_dfp[0];
                if(category_slug_dfp) that.dfpSlots[iterator].setTargeting('category', category_slug_dfp);

                // 0-NPA, 1-PA
                if (consent[2]) {
                    that.dfpSlots[iterator].setTargeting('gad-type', '1');
                } else {
                    that.dfpSlots[iterator].setTargeting('gad-type', '0');
                }

                // Roxot code
                // if (consent) {
                    that.dfpSlots[iterator].setTargeting('roxot-sector-id', that.getRoxotSectorId());
                    that.dfpSlots[iterator].setTargeting('roxot-deep', that.getRoxotDeep());
                    that.dfpSlots[iterator].setTargeting('roxot-event', that.getRoxotEvent());
                // }

                googletag.display(unitDivId);

                dfpSlotsPortion.push(that.dfpSlots[iterator]);

                // Add footer unit in array to refresh
                if(unitName === window.config.footerUnitName){
                    // console.log('footer with name ' + unitName + ' added to array to refresh');
                    that.dfpSlotsToRefresh.push(that.dfpSlots[iterator]);
                }
            });

            adsPortion.push({
                'adPlacement': adPlacement,
                'unitName': unitName,
                'unitDivId': unitDivId,
                'prebidConfig': prebidConfig
            });

            // adPlacement.style.backgroundColor = '#f36c00';

        }

        // Prepare prebid config
        let prebidUnitsConfig = adsPortion.map(ad => {
            if (ad.prebidConfig === undefined) return;
            let unitConfig = JSON.parse(JSON.stringify(ad.prebidConfig));
            unitConfig.code = ad.unitDivId;
            return unitConfig;
        });
        prebidUnitsConfig = prebidUnitsConfig.filter(function (item) {
            return (item != undefined);
        });



        // DFP part
        googletag.cmd.push(function () {
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
        });


        this._refreshSlots(dfpSlotsPortion, prebidUnitsConfig);



    },
    getAdPlacementsWithinNScreensFromCurrent: function (container, distance, direction, isFixedUnit) {

        distance = distance || 3;
        direction = (direction === undefined) ? 'down' : direction;

        let result = [];

        let placements = container.querySelectorAll('.adPlacement');

        if(isFixedUnit) return placements;

        for (let i = 0; i < placements.length; i++) {
            let placement = placements[i];
            let viewportOffset = placement.getBoundingClientRect();
            let viewportHeight = window.document.documentElement.clientHeight;
            let offset = {
                top: viewportOffset.top - helper.config.headerHeight,
                bottom: viewportOffset.bottom - helper.config.headerHeight
            };

            let distanceToAd;

            // set distanceToAd
            if (direction === 'down') {
                distanceToAd = offset.top - viewportHeight;
            } else {
                distanceToAd = offset.bottom * -1;
            }

            // add placements to result
            let distanceToMiddleOfAd = parseInt(distanceToAd + (placement.offsetHeight / 2));

            if (distanceToAd < (viewportHeight * distance) && distanceToMiddleOfAd > (viewportHeight * -1)) {
                // debug
                // placement.setAttribute('debug-lazy-load', '+');
                result.push(placement);
            } else {
                // debug
                // placement.setAttribute('debug-lazy-load', '-');
            }

            // console.log(direction, distanceToMiddleOfAd);

        }
        return result;
    },
    listenForScroll: function (container) {
        if (container.dataset.scrollListenerAttached === '1') return;
        container.setAttribute('data-scroll-listener-attached', '1');
        let that = this;
        let timer;
        let timeout = helper.config.lazyLoadTimeout;
        helper.addEvent(window, 'slideScrolledDown', function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
                that.addAds(container, 'down');
            }, timeout);
        });
        helper.addEvent(window, 'slideScrolledUp', function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
                that.addAds(container, 'up');
            }, timeout);
        });
    },
    handleFooterUnit: function (dfpEvent) {
        console.log('handleFooterUnit v5');
        // Once height > 1 init();
        // after 500ms show();
        // check height every 1s and update widget height

        let showTimer = setInterval(() => {
            let creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
            let isEmpty = dfpEvent.isEmpty;

            if(!isEmpty && (creativeHeight > 1)){
                FooterWidget.init(dfpEvent);
                setTimeout(() => {
                    FooterWidget.show(dfpEvent);
                    window.updateFooterHeightTimer = setInterval(() => { FooterWidget.updateHeight(dfpEvent); }, 1000);
                }, 500);
                clearInterval(showTimer);
            }
            if(isEmpty === true){
                clearInterval(showTimer);
            }else if(isEmpty === false){
                // good
            }else{
                console.warn('handleFooterUnit received unknown dfpEvent.isEmpty');
            }
        }, 500);
        setTimeout(() => {
            // let creativeHeight = (dfpEvent.size) ? dfpEvent.size[1] : undefined;
            let creativeHeight = this.getHeightOfRenderedUnit(dfpEvent);
            let isEmpty = dfpEvent.isEmpty;




            if(!isEmpty && creativeHeight <= 1){
                FooterWidget.hide(dfpEvent);
            }

            if(isEmpty){
                FooterWidget.hide(dfpEvent);
            }
        }, 3000);
    },
    _getPrebidConfig: function (unitName, unitDivId) {
        let prebidConfig;
        if ((window.config.adUnits[unitName] && window.config.adUnits[unitName].prebidConfig)) {
            prebidConfig = window.config.adUnits[unitName].prebidConfig;
        }

        let unitNameWithNoNNN = unitName.replace(/_\d{1,2}$/, '_NNN');
        if ((window.config.adUnits[unitNameWithNoNNN] && window.config.adUnits[unitNameWithNoNNN].prebidConfig)) {
            prebidConfig = window.config.adUnits[unitNameWithNoNNN].prebidConfig;
        }

        if(prebidConfig && unitDivId){
            prebidConfig = JSON.parse(JSON.stringify(prebidConfig));
            prebidConfig.code = unitDivId;
        }
        return prebidConfig;
    },
    _getPrebidConfigForSlots: function (slots){
        if(slots.length === 0) {
            console.warn('_getPrebidConfigForSlots called with empty slots parameter');
            return;
        }

        let prebidConfig = slots
            .filter(slot => slot.prebidConfig !== undefined)
            .map(slot => slot.prebidConfig);

        return prebidConfig;
    },
    _sendPrebidRequest: function (prebidUnitsConfig, sendAdserverRequest) {
        if (prebidUnitsConfig && prebidUnitsConfig.length > 0) {
            window.pbjs.que.push(function () {
                window.pbjs.adUnits = [];
                window.pbjs.addAdUnits(prebidUnitsConfig);
                window.pbjs.requestBids({
                    bidsBackHandler: sendAdserverRequest
                });
            });
        } else {
            sendAdserverRequest();
        }
    },
    _sendAdserverRequest: function (dfpSlotsPortion, controlSendRequest) {
        // controlSendRequest.fp_hb_scripts_counter--;
        // if (controlSendRequest.fp_hb_scripts_counter > 0) return;

        if (controlSendRequest.adserverRequestSent) return;
        controlSendRequest.adserverRequestSent = true;
        let timer = [0];
        let intrrval = helper.config.adLoadDelay;

        googletag.cmd.push(function () {
            window.pbjs.que.push(function () {
                window.pbjs.setTargetingForGPTAsync();
            });




            /*
             * split array like this ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']
             * into this
             * ['a', 'b', 'c']
             * ['d', 'e', 'f']
             * ['j', 'h', 'i']
             * ['j']
             */
            let dfpSlotsPortionSplitted = [];
            let inFeedSlots = [];
            let maxSizeOfSlotsCollection = window.config.adUnitsCopiesAmount;

            dfpSlotsPortion.forEach(slot => {
                if (/_[0-9]{1,2}$/.test(slot.getAdUnitPath())) {
                    inFeedSlots.push(slot);
                } else {
                    dfpSlotsPortionSplitted.push(slot);
                }
            });

            while (inFeedSlots.length > 0) {
                dfpSlotsPortionSplitted.push(inFeedSlots.splice(0, maxSizeOfSlotsCollection));
            }
            // console.log(dfpSlotsPortionSplitted);

            dfpSlotsPortionSplitted.forEach(part => {
                setTimeout(() => {
                    if (typeof part.getName === "undefined") {
                        googletag.pubads().refresh(part);
                    } else {
                        googletag.pubads().refresh([part]);
                    }
                    // typeof part.getName === "undefined" ? googletag.pubads().refresh(part) : googletag.pubads().refresh([part]);
                }, timer[0]);

                timer[0] = timer[0] + intrrval;

            })

        });
    },
    _refreshSlots: function (dfpSlotsPortion, prebidUnitsConfig) {

        let that = this;

        let controlSendRequest = {
            fp_hb_scripts_counter: 2,
            adserverRequestSent: false
        };

        this._sendPrebidRequest(prebidUnitsConfig, () => {that._sendAdserverRequest(dfpSlotsPortion, controlSendRequest)});


        setTimeout(function () {
            that._sendAdserverRequest(dfpSlotsPortion, controlSendRequest);
        }, window.PREBID_TIMEOUT);
    },
    getHeightOfRenderedUnit: function(dfpEvent) {
        // Is has duplicate in FooterWidget
        return document.getElementById(dfpEvent.slot.getSlotElementId()).querySelector('iframe').offsetHeight;
    }
};